import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WVCustom, WVMain } from '../wallboard-view.model';

@Component({
    selector: 'cv-wallboard-view-custom',
    templateUrl: './wallboard-view-custom.component.html',
    styleUrls: ['./wallboard-view-custom.component.scss']
})
export class WallboardViewCustomComponent implements OnInit, OnDestroy {
    @Input() firstSlide = true;

    public wvf: WVMain;
    public wvcf: WVCustom;
    public modules: any[];

    private isDestroyed: boolean = false;
    private _backgroundID: number = 0;
    private _moduleKey: string = "";

    get moduleKey(): string {
        return this._moduleKey;
    }

    get backgroundID(): number {
        return this._backgroundID;
    }
    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;
        this._backgroundID = this.wvcf?.Slide.BackgroundImageID ?? 0;
        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[0]?.WallboardModuleKey ?? "";

        this.modules = this.wvcf.Slide.WallboardModuleDetails;

        this.wvcf.cellHeight = $("#wallboardViewArea").height() / 40.0;
        this.wvcf.cellWidth = $("#wallboardViewArea").width() / 40.0;

        this.wvf.RunSlide = this.firstSlide;

        Promise.resolve().then(() => {
            if (this.firstSlide)
                this.wvf.FirstSlideReady = true;
            else
                this.checkDataReady();
        })
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    checkDataReady() {
        // If all the modules on the custom slide have pre-loaded or if there are no modules, let WallboardViewMain know next slide is ready.
        if (this.wvf.Slides[this.wvf.NextSlide].WallboardModuleDetails.length === 0) {
            this.wvf.NextSlideReady = true;
            this.wvcf.ReadyModules = [];
        }
        else if (this.wvcf.ReadyModules.length >= this.wvf.Slides[this.wvf.NextSlide].WallboardModuleDetails.length) {
            this.wvf.NextSlideReady = true;
            this.wvcf.ReadyModules = [];
        }
        else if (!this.isDestroyed) {
            setTimeout(() => {
                this.checkDataReady();
            }, 1000);
        }
    }
}
